import {
    GRID_COLUMN_DRAG_ATTR,
    GRID_COLUMN_SHIFT_MS
} from '../../../utils/gridColumnDrag';

const cells = (state, tag = '') =>
    state
        .split(' ')
        .map((s) => `& ${tag}[${GRID_COLUMN_DRAG_ATTR}="${s}"]`)
        .join(', ');

// A head cell the user can drag to move its column shows a grip (see
// GridColumnDragGrip) and the grab cursor. While a column is dragged (see
// gridColumnDrag.js) its cells are lifted — raised on the dropdown shadow,
// opaque, above the others — and follow the pointer with no delay; the other
// columns glide aside to show where it will land, and glide back if the drag
// is called off. Spread into the grid table's sx.
export const gridColumnDndSx = {
    '& th[data-reorderable]': {
        cursor: 'grab'
    },
    [`& [${GRID_COLUMN_DRAG_ATTR}]`]: {
        willChange: 'transform'
    },
    [cells('shifting returning')]: {
        transition: `transform ${GRID_COLUMN_SHIFT_MS}ms cubic-bezier(0.2, 0, 0, 1)`
    },
    [cells('lifted settling')]: {
        boxShadow: (theme) => theme.customShadows.dropdown
    },
    [cells('lifted settling', 'td')]: {
        position: 'relative',
        zIndex: 1,
        backgroundColor: 'background.paper'
    },
    // Carried to the remove zone: the column fades in its place.
    [cells('removing')]: {
        opacity: 0.4,
        transition: 'opacity 120ms ease-out'
    },
    // Above the sticky head cells it passes (z-index 2).
    [cells('lifted settling', 'th')]: {
        zIndex: 3
    },
    // No resize edge on a column in motion.
    [`& th[${GRID_COLUMN_DRAG_ATTR}] > [role="separator"]`]: {
        visibility: 'hidden'
    },
    '@media (prefers-reduced-motion: reduce)': {
        [`& [${GRID_COLUMN_DRAG_ATTR}]`]: {
            transition: 'none !important'
        }
    }
};
